import React, { useEffect, useState, useRef, Suspense, memo } from "react";
import { useObjectStore } from "../zustand/objects";
import { Accordion, Card, Button, Image, Text, Group, Badge, ActionIcon, Grid } from '@mantine/core';
import {getComments} from '../api'
import DeleteIcon from '@mui/icons-material/Delete';



const SidebarCommentThread = ({id, position, artboard, currentObjectArtboard}) => {

const {threads, addComment, deleteThread, loadThreads, viewedComments, viewedThread, setViewedComments, setViewedThread, scrubViewedComments} = useObjectStore()

const [open, setOpen] = useState()
const messagesEndRef = useRef(null); // Reference to the bottom of the scrollable div

const handleDelete = () => {
  deleteThread(id)
  setTimeout(() => {
    loadThreads()
  }, "500");  
}

useEffect(() => {
  setTimeout(() => {
    viewedThread === id && viewedComments.length > 0 && messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
  }, 200);
},[viewedComments.length])


const handleOpenAccordion = () => {
  setOpen(true)
  setViewedThread(id)
  setTimeout(() => {
    viewedThread === id && viewedComments.length > 0 && messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
  }, 200);
}


      const loadComments = () => {
         getComments(id)
        .then(res => setViewedComments(res))
        setTimeout(() => {
          viewedThread === id && viewedComments.length > 0 && messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }

      useEffect(() => {
       open && loadComments()
      },[open])
    
    
    return (

        <Accordion.Item label="comments" variant="contained" onChange={handleOpenAccordion}>
          <Accordion.Control>Comment</Accordion.Control>
          <Accordion.Panel>
            {viewedThread === id && viewedComments.map((mapped, i) => (
                    <UserComment id={mapped.id} threadId={id} userNameProp={mapped.author} commentDateProp={new Date(mapped.created_at).toLocaleDateString()} fullTextProp={mapped.comment_content} loadComments={loadComments} />
                    ))}
            <div ref={messagesEndRef} />
            </Accordion.Panel>
        </Accordion.Item>

    )

    }

    export default SidebarCommentThread

    const UserComment = ({id, threadId, userNameProp, commentDateProp, fullTextProp, loadComments}) => {
    
        const {deleteComment} = useObjectStore()
    
        const [hover, setHover] = useState(false)
    
        const handleDelete = () => {
          deleteComment(threadId, id)
          // setTimeout(() => {
          //   loadComments()
          // }, "500");  
        }
    
        return (
          <Grid style={{
            paddingBottom: 0
          }}>
              <Grid.Col pb={0} span={5}><div style={{paddingLeft:10, paddingTop:10, paddingBottom:0}}>
              <Text size="sm" fw={500}>{userNameProp}</Text></div></Grid.Col>
              <Grid.Col pb={0} span={5}><div style={{paddingRight:10, paddingTop:10, paddingBottom:0}}>
              <Text size="sm">{commentDateProp}</Text></div></Grid.Col>
              <Grid.Col pb={0} span={2}>
              <ActionIcon ml={5} w={30} h={40} variant="transparent" size={'xs'} onClick={() => handleDelete()}
                          onPointerOver={() => setHover(true)}
                          onPointerLeave={() => setHover(false)}
                          color={!hover ? "#424242" : "#868e96"} >
                          <DeleteIcon fontSize='medium' /></ActionIcon></Grid.Col>
              <Grid.Col span={12} pt={0}><div style={{paddingLeft:10, paddingRight:10, paddingTop:0}}>
              <Text size="sm">{fullTextProp}</Text></div></Grid.Col>                    
            </Grid>
        )
      } 